exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /storage/data/github/tests/angular-data-table-component/angular-4/src/app/examples/empty/empty.component.css
// module id = ../../../../../src/app/examples/empty/empty.component.css
// module chunks = main